// extracted by mini-css-extract-plugin
module.exports = {"rating":"eS"};